import { ImpersonationForm } from "@/components/admin/ImpersonationForm";
import { Toaster } from "@/components/ui/toaster";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";

export function AdminImpersonationPage() {
    const { session } = useAuth();

    if (session) {
        return <Navigate to="/dashboard" replace />;
    }

    return (
        <div className="flex h-screen w-full items-center justify-center px-4 bg-gradient-to-br from-red-100 via-orange-100 to-yellow-100">
            <ImpersonationForm />
            <Toaster />
        </div>
    );
}
